import { render, staticRenderFns } from "./addLoginConfig.vue?vue&type=template&id=4d9b9430&"
import script from "./addLoginConfig.vue?vue&type=script&lang=js&"
export * from "./addLoginConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9b9430')) {
      api.createRecord('4d9b9430', component.options)
    } else {
      api.reload('4d9b9430', component.options)
    }
    module.hot.accept("./addLoginConfig.vue?vue&type=template&id=4d9b9430&", function () {
      api.rerender('4d9b9430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/addLoginConfig.vue"
export default component.exports